<div class="confirm-sap-order-dialog-container">

    <div class="confirm-sap-orderid-main-container">
        <div class="confirm-sap-order-id-container">
            <p class="confirm-sap-order-id-text">ORDER NO:</p> <span><p class="confirm-sap-order-id-no">{{orderNumber ? orderNumber : placeholder}}</p></span>
        </div>
        <div class="confirm-sap-order-id-date-container">
            <p class="confirm-sap-order-id-date-text">Order Date:</p> <span><p class="confirm-sap-order-id-date-no">{{orderDate ? dayjs(orderDate).format(dateStringFormatting) : placeholder}}</p></span>
        </div>
    </div>



    <div class="confirm-sap-order-info-container">
        <div class="confirm-sap-order-address-headers">
            <p class="confirm-sap-order-info-header-text">Approval Required:</p>
            <p class="confirm-sap-order-info-header-text">Discount Exceeded:</p>
            <p class="confirm-sap-order-info-header-text">Terms Exceeded:</p>
            <p class="confirm-sap-order-info-header-text">Order Older Than 30 days:</p>
<!--            <p class="confirm-sap-order-info-header-text">Sales Price Required:</p>-->

        </div>
        <div class="confirm-sap-order-details-container">
            <ng-container>
                <p class="confirm-sap-order-info-text" [ngClass]="approvalRequired ? 'yes-red' : 'no-green' ">{{approvalRequiredDisplay}}</p>
                <p class="confirm-sap-order-info-text" [ngClass]="isOutsideDiscountLev ? 'yes-red' : 'no-green' ">{{totalDisc}}</p>
                <p class="confirm-sap-order-info-text" [ngClass]="isTermExceeded ? 'yes-red' : 'no-green' ">{{termDaysExceed}}</p>
                <p class="confirm-sap-order-info-text" [ngClass]="isOrderDateExpired ? 'yes-red' : 'no-green' ">{{orderDateExpired}}</p>
<!--                <p class="confirm-sap-order-info-text">NO</p>-->
            </ng-container>

        </div>
    </div>

    <div class="confirm-sap-order-btn-dialog-container">

        <button class="cancel-confirm-sap-order-dialog-btn" mat-flat-button type="button" (click)="cancelSubmitToSap()">
            <div class="cancel-confirm-sap-btn-content">
                <span><p class="cancel-confirm-sap-order-btn-text">CANCEL</p></span>
            </div>
        </button>

                <button  class="confirm-sap-submit-btn" mat-flat-button type="button" (click)="triggerSubmitToSap()">
                    <div class="confirm-sap-submit-btn-content">
                        <img src="../../../../../assets/order-to-cash-icons/save.svg" alt="Save Icon" class="confirm-sap-submit-btn-icon">
                        <span><p class="confirm-sap-submit-btn-text">SUBMIT TO SAP</p></span>
                    </div>
                </button> 
    </div>

</div>
